import UserActionTypes from './user.types'
import { fetchCurrentUser, getCloudUserInfo } from '../../services/server-api/server-api.service'
import loadNIASScript from '../../utils/load-nias-script'

export const fetchUserRequest = () => ({
  type: UserActionTypes.FETCH_USER_REQUEST
})

export const fetchUserSuccess = (user) => ({
  type: UserActionTypes.FETCH_USER_SUCCESS,
  payload: user
})

export const fetchUserFailure = (error) => ({
  type: UserActionTypes.FETCH_USER_FAILURE,
  payload: error
})

export const fetchUserInfoRequest = () => ({
  type: UserActionTypes.FETCH_USER_INFO_REQUEST
})
export const fetchUserInfoFailure = (error) => ({
  type: UserActionTypes.FETCH_USER_INFO_FAILURE,
  payload: error
})
const fetchUserInfoSuccess = (userInfo) => ({
  type: UserActionTypes.FETCH_USER_INFO_SUCCESS,
  payload: userInfo
})

export const fetchUserAsync = (token) => {
  return async dispatch => {
    dispatch(fetchUserRequest())
    try {
      const user = await fetchCurrentUser(token)
      loadNIASScript(user, token)
      dispatch(fetchUserSuccess(user))
    } catch (error) {
      dispatch(fetchUserFailure({ message: error.message, data: error.data}))
    }
  }
}

export const fetchUserInfoAsync = (selectedTsp,token) => {
  return async dispatch => {
    dispatch(fetchUserInfoRequest())
    try {
      const user = await fetchCurrentUser(token)
      if(!user) {
        loadNIASScript(null, token)
      }   
      const cloudUser = await getCloudUserInfo(selectedTsp, user, token)
      
      dispatch(fetchUserInfoSuccess({user, cloudUser}))
    } catch (error) {
      dispatch(fetchUserInfoFailure({ message: error.message, data: error.data}))
    }
  }
}
